var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-toggle-input',_vm._b({attrs:{"checked":_vm.is_checked},on:{"change":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},'base-toggle-input',_vm.base_toggle_input,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }